const useOccupancyList = [
  "Primary Residence",
  "Second Home",
  "Investment Property",
];
export default useOccupancyList;
